const { Player } = window.Vimeo

class EmbeddedVideo extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['video']
  }

  constructor () {
    super()

    this.videos = this.els.video.elements.map(element => {
      return {
        element,
        player: new Player(element),
      }
    })

    this.observer = new IntersectionObserver(
      this.observeViewportEntry.bind(this),
    )
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', () => this.playVisibleVideo())

    if (this.autoplay) {
      this.videos.forEach(({ element }) => {
        this.observer.observe(element)
      })
    }

    this.videos.forEach(video => {
      video.player.on('playing', () => {
        this.isPlaying = true
      })

      video.player.on('bufferend', () => {
        this.atBufferend = true
      })
    })
  }

  /** @type {IntersectionObserverCallback} */
  observeViewportEntry (entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        return
      }

      const associatedVideo = this.videos.find(
        ({ element }) => element === entry.target,
      )
      if (!associatedVideo) {
        return
      }

      this.playVideo(associatedVideo.player)
      this.observer.unobserve(associatedVideo.element)
    })
  }

  playVisibleVideo () {
    this.playVideo(this.visibleVideo.player)
  }

  async playVideo (video) {
    await video.ready()

    await Promise.resolve(
      video.getAutopause().then(async () => {
        await video.getPaused()
      }),
    )

    video.play()
  }

  get autoplay () {
    return this.hasAttribute('autoplay')
  }

  /** @returns {boolean} */
  get isPlaying () {
    return this.hasAttribute('playing')
  }

  set isPlaying (playing) {
    return this.toggleAttribute('playing', playing)
  }

  /** @returns {boolean} */
  get atBufferend () {
    return this.hasAttribute('bufferend')
  }

  set atBufferend (bufferend) {
    return this.toggleAttribute('bufferend', bufferend)
  }

  get visibleVideo () {
    return this.videos.find(
      video => window.getComputedStyle(video.element).display !== 'none',
    )
  }
}

if (!customElements.get('embedded-video')) {
  customElements.define('embedded-video', EmbeddedVideo)
}
